<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconFirefoxLogo_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M10.71 1.305a.292.292 0 0 0-.248.521c1.16.79 1.87 2.902 1.913 4.56a3.8 3.8 0 0 0-1.095-1.283.292.292 0 0 0-.408.408 3.208 3.208 0 0 1-2.58 5.114 2.4 2.4 0 0 1-.955-.152c.332-.138.65-.31.946-.514a2.35 2.35 0 0 1 1.176-.5.292.292 0 0 0 .283-.363 1.144 1.144 0 0 0-1.158-.804 1 1 0 0 0-.753.298c-.157.14-.32.285-.996.285-1.193 0-1.75-.696-1.75-1.166a.6.6 0 0 1 .255-.434q.195-.138.413-.233a.3.3 0 0 0 .413 0 .69.69 0 0 0 .144-.675l1.56-1.04a.292.292 0 0 0-.16-.535h-.584c-.649 0-1.073-.126-1.166-.345-.134-.322.306-1.008.788-1.49a.292.292 0 0 0-.205-.497c-.767.068-1.459.49-1.873 1.139a6.3 6.3 0 0 0-1.32.02 1.5 1.5 0 0 1-.233-.35 3 3 0 0 1-.365-1.101.292.292 0 0 0-.498-.207 2.3 2.3 0 0 0-.449 2.491 7 7 0 0 0 6.196 10.255C11.926 14.707 15 11.761 15 8v-.583c0-3.558-2.216-5.49-4.29-6.112"
    />
</svg>
